import { Pressable, StyleSheet, Text, View } from 'react-native';

import { colors } from '@/src/theme/colors';
import { spacing } from '@/src/theme/spacing';

import type { FeedMode } from './post-service';

export function FeedModeToggle({
  mode,
  onChange,
}: {
  mode: FeedMode;
  onChange: (mode: FeedMode) => void;
}) {
  return (
    <View
      accessibilityLabel="Feed order"
      accessibilityRole="tablist"
      style={styles.wrap}
    >
      {(['ranked', 'latest'] as const).map((option) => {
        const selected = mode === option;

        return (
          <Pressable
            key={option}
            accessibilityRole="tab"
            accessibilityState={{ selected }}
            onPress={() => {
              if (!selected) {
                onChange(option);
              }
            }}
            style={({ pressed }) => [
              styles.option,
              selected ? styles.optionSelected : null,
              pressed ? styles.optionPressed : null,
            ]}
          >
            <Text
              style={[
                styles.optionText,
                selected ? styles.optionTextSelected : null,
              ]}
            >
              {option === 'ranked' ? 'Ranked' : 'Latest'}
            </Text>
          </Pressable>
        );
      })}
    </View>
  );
}

const styles = StyleSheet.create({
  option: {
    alignItems: 'center',
    borderRadius: 999,
    flex: 1,
    minHeight: 38,
    justifyContent: 'center',
    paddingHorizontal: spacing.md,
  },
  optionPressed: {
    opacity: 0.8,
  },
  optionSelected: {
    backgroundColor: colors.primary,
  },
  optionText: {
    color: colors.mutedText,
    fontSize: 14,
    fontWeight: '900',
  },
  optionTextSelected: {
    color: colors.surface,
  },
  wrap: {
    backgroundColor: colors.surfaceTint,
    borderColor: colors.border,
    borderRadius: 999,
    borderWidth: 1,
    flexDirection: 'row',
    gap: spacing.xs,
    padding: spacing.xs,
  },
});
